<template>
    <SensorDetailDialogWin
        :baseMsg="baseMsg"
        :detailObj="detailObj"
        :deviceType="newDeviceType"
        :deviceProperty="deviceProperty"
        :detailLoading="detailLoading"
        :detailRuleObj="detailRuleObj"
        :detailNetObj="detailNetObj"
        v-bind="$attrs"
        @changdetail="changdetail"
    ></SensorDetailDialogWin>
</template>

<script>
import SensorDetailDialogWin from './component/SensorDetailDialogWin.vue';
import { sensorGetSensorDetailInfo } from '@/api/modules/sensor.js';
export default {
    props: ['id', 'name', 'show'],
    components: {
        SensorDetailDialogWin
    },
    data() {
        return {
            baseMsg: [
                {
                    text: 'public.belong',
                    key: 'url',
                    content: ''
                },
                {
                    text: $t('integration.mount_'),
                    key: 'carrierName',
                    content: ''
                },
                {
                    text: $t('integration.sensor_number'),
                    key: 'tagId',
                    content: ''
                },
                {
                    text: $t('integration.sensor_type'),
                    key: 'type',
                    content: ''
                },

                {
                    text: $t('integration.sensor_status'),
                    key: 'status',
                    content: ''
                },
                {
                    text: 'device.config_status',
                    key: 'configStatus',
                    content: ''
                },
                {
                    text: 'public.table_create_time',
                    key: 'createTime',
                    content: ''
                },
                {
                    key: 'nickname',
                    text: 'device.nickname',
                    content: ''
                },
                {
                    key: 'description',
                    text: $t('public.table_desc'),
                    content: ''
                },
              {
                key: 'location',
                text: $t('public.location_desc'),
                content: ''
              },
              {
                key: 'group',
                text: $t('public.group_desc'),
                content: ''
              }
            ],
            detailRuleObj: [
                {
                    key: 'collectInterval',
                    text: $t('integration.acquisition_interval'),
                    isBool: true
                },
                {
                    key: 'exCollectInterval',
                    text: $t('integration.abnormal_collection_interval'),
                    isBool: true
                },
                {
                    key: 'tempCollectInterval',
                    text: $t('integration.temperature_acquisition_interval'),
                    isBool: true
                },
                {
                    key: 'tempChange',
                    text: $t('integration.temperature_change_threshold'),
                    isBool: true
                },
                {
                    key: 'tempMaxReport',
                    text: $t('integration.maximum_temperature_reporting_interval'),
                    isBool: true
                },
                {
                    key: 'tempMinReport',
                    text: $t('integration.minimum_temperature_reporting_interval'),
                    isBool: true
                },

                {
                    key: 'humCollectInterval',
                    text: $t('integration.humidity_collection_interval'),
                    isBool: true
                },
                {
                    key: 'humChange',
                    text: $t('integration.humidity_change_threshold'),
                    isBool: true
                },
                {
                    key: 'humMaxReport',
                    text: $t('integration.maximum_humidity_reporting_interval'),
                    isBool: true
                },
                {
                    key: 'humMinReport',
                    text: $t('integration.humidity_minimum_reporting_interval'),
                    isBool: true
                }
            ],
            detailNetObj: [
                {
                    key: 'extPanId',
                    text: 'Ext Pan ID',
                    isBool: true
                },
                {
                    key: 'channelPage',
                    text: 'Join Attemp',
                    isBool: true
                },
                {
                    key: 'transmitPower',
                    text: 'device.transmit_power',
                    isBool: true
                },
                {
                    key: 'channelMask',
                    text: 'device.channel_mask',
                    isBool: true
                },
                {
                    key: 'inNetInterval',
                    text: 'device.in_net_interval',
                    isBool: true
                },
                {
                    key: 'devEui',
                    text: 'DevEUI',
                    isBool: true
                },
                {
                    key: 'appEui',
                    text: 'AppEUI',
                    isBool: true
                },
                {
                    key: 'appKey',
                    text: 'AppKey',
                    isBool: true
                }
            ],
            detailObj: null,
            newDeviceType: {},
            deviceProperty: {},
            detailLoading: false
        };
    },
    methods: {
        detailFn(id) {
            // console.log('row===>', row);
            this.detailLoading = true;
            sensorGetSensorDetailInfo(id)
                .then(({ result, state }) => {
                  console.log(result.sensor);
                    result.sensor.pictureBase64 = result.sensor.pictureBase64 || result.deviceType.pictureBase64;
                    this.detailObj = result.sensor;
                    this.newDeviceType = result.deviceType;
                    this.deviceProperty = result.deviceProperty || {};
                    const { sensor, appConfig, netConfig } = result;
                    // 基本的数据
                    sensor.createTime = this.$timetransition(sensor.createTime);
                    this.baseMsg.forEach(item => {
                        for (const newKey in sensor) {
                            item.key === newKey ? (item.content = sensor[newKey]) : null;
                            if (item.key === 'url') {
                                item.content = `${sensor.fullPath}/${sensor.carrierName}`;
                            }
                        }
                    });
                    this.getGenerValueFn(this.detailRuleObj, appConfig);
                    this.getGenerValueFn(this.detailNetObj, netConfig);
                })
                .finally(() => {
                    this.detailLoading = false;
                });
        },
        getGenerValueFn(array = [], obj) {
            array.forEach(item => {
                item.content = '';
                for (const newKey in obj) {
                    item.key === newKey ? (item.content = obj[newKey]) : null;
                }
            });
        },
        changdetail() {
            this.detailFn(this.$route.query.id);
        }
    },
    mounted() {
        // win
        if (this.$route.query && this.$route.query.id) {
            const { id } = this.$route.query;
            this.detailFn(id);
        }
    }
};
</script>

<style></style>
